<template>
	<c-dialog ref="dialog" width="500" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="id" ></c-input>
			<c-form-item label="机台编号" required>
				<c-input name="equipment_code" placeholder="请输入机台编号"></c-input>
			</c-form-item>
			<c-form-item label="设备ID" tip="用于与第三方设备厂商系统对接">
				<c-input name="device_id" placeholder="请输入三方设备ID"></c-input>
			</c-form-item>
			<c-form-item label="状态" required>
				<c-radio-group name="state" :options="disableEnableDic"></c-radio-group>
			</c-form-item>
			<c-form-item label="备注说明">
				<c-input type="textarea" name="remark"></c-input>
			</c-form-item>
			<!--自定义字段控件-->
			<custom-form ref="customForm" work-type="70"></custom-form>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex';
	
export default {
	computed: {
		...mapState(['disableEnableDic'])
	},
	
	data() {
		return {
			editState: false
		}
	},

	methods: {
		/*********打开编辑框，初始化**********/
		open(data) {
			this.editState = !!data;
			this.$refs.customForm.init();
			this.$refs.form.clear();
			
			if (data) {
				this.$refs.form.set(data);
			} else {
				this.$refs.form.set({state: 1});
			}
			this.$refs.dialog.open({
				title: data ? '编辑机台' : '创建机台'
			});
		},

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this.editState?'/equipment/edit':'/equipment/add',
				rule: {
					equipment_code: '请输入机台编号',
					state: '请选择状态',
					...this.$refs.customForm.rule
				},
				dataFormatter: data => {
					data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message: '提交成功',
						type: 'success'
					});
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>
